"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _utils = require("@alycecom/utils");

var _profile = require("../Shapes/profile.shape");

var _social = require("../constants/social.constants");

var _useTrackGiftingFlow = require("../CreateGift/hooks/useTrackGiftingFlow");

var _ContactDetailsCard = _interopRequireDefault(require("./ContactDetailsCard"));

var _GiftsStatistic = _interopRequireDefault(require("./GiftsStatistic"));

var _UnsubscribedErrorMessage = _interopRequireDefault(require("./UnsubscribedErrorMessage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    listItem: {
      alignItems: 'flex-start'
    },
    emptyListItem: {
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    listIcon: {
      paddingTop: 2,
      minWidth: 'auto',
      marginRight: spacing(2)
    },
    socialLink: {
      color: palette.link.main
    },
    listItemText: {
      padding: 0,
      margin: 0
    },
    spyIcon: {
      cursor: 'default'
    },
    privacyIcon: {
      color: palette.text.primary
    },
    divider: {
      margin: "".concat(spacing(1), " 0")
    },
    linkIcon: {
      color: palette.link.main,
      fontSize: 14,
      width: 16,
      lineHeight: 14,
      marginLeft: 4,
      cursor: 'pointer'
    },
    loadingLabel: {
      height: 14,
      marginTop: spacing(5 / 8),
      width: 96
    }
  };
});

var ContactProfile = function ContactProfile(_ref2) {
  var profile = _ref2.profile,
      isLoading = _ref2.isLoading,
      handleGiftViewHistory = _ref2.handleGiftViewHistory,
      handleGiftCreate = _ref2.handleGiftCreate,
      user = _ref2.user;
  var classes = useStyles();
  var openLink = (0, _react.useCallback)(function (link) {
    window.open(link, '_blank');
  }, []);
  var isLinksTagsEmpty = (0, _react.useMemo)(function () {
    return R.isEmpty(profile.researchTags.filter(function (tag) {
      return !R.isEmpty(tag.tags);
    }));
  }, [profile.researchTags]);
  var showEmptyTagsMessage = (0, _react.useMemo)(function () {
    return R.isEmpty(profile.researchTags) && !isLoading;
  }, [profile.researchTags, isLoading]);
  var renderLoadingList = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_material.List, {
      disablePadding: true
    }, /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
        className: classes.loadingLabel
      })
    })), /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
        className: classes.loadingLabel
      })
    })), /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
        className: classes.loadingLabel
      })
    })));
  }, [classes]);
  var renderProfileList = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_material.List, {
      disablePadding: true
    }, profile.email && /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
      className: classes.listIcon
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      icon: "envelope"
    })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: profile.email
    })), profile.location && /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
      className: classes.listIcon
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      icon: "home"
    })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: profile.location
    })), profile.phoneNumber && /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
      className: classes.listIcon
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      icon: "phone"
    })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: profile.phoneNumber
    })));
  }, [classes, profile.email, profile.location, profile.phoneNumber]);
  var trackSocialLink = (0, _useTrackGiftingFlow.useTrackGiftingFlowSocialLinkVisited)(user);
  var socialClickHandler = (0, _react.useCallback)(function (resource, openFunc) {
    trackSocialLink(_useTrackGiftingFlow.GIFTING_TRACK_TABS.ABOUT, resource);

    if (openFunc) {
      openFunc();
    }
  }, [trackSocialLink]);
  var contactTitle = (0, _react.useMemo)(function () {
    return (0, _utils.isEmptyString)(profile.firstName) ? profile.email : profile.firstName;
  }, [profile]);
  var renderResearchList = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_material.List, {
      disablePadding: true
    }, profile.researchTags.map(function (tag) {
      var linkTitle = R.toLower(tag.title);
      var icon = _social.socialNames.includes(linkTitle) ? ['fab', linkTitle] : 'globe';
      return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
        key: tag.title,
        disableGutters: true,
        className: classes.listItem
      }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
        className: classes.listIcon
      }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
        icon: icon,
        className: classes.socialLink
      })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
        className: classes.listItemText,
        primary: tag.tags.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tag.tags.join(', '), /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
          icon: "external-link",
          className: classes.linkIcon,
          onClick: function onClick() {
            return socialClickHandler(tag.title, openLink(tag.url));
          }
        })) : /*#__PURE__*/_react.default.createElement(_material.Link, {
          href: tag.url,
          target: "_blank",
          onClick: function onClick() {
            return socialClickHandler(tag.title);
          }
        }, "View ", tag.title, " profile")
      }));
    }), profile.discoveryNotes && /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
      className: classes.listIcon
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      icon: "comments"
    })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: profile.discoveryNotes
    })), (showEmptyTagsMessage || isLinksTagsEmpty) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !showEmptyTagsMessage && /*#__PURE__*/_react.default.createElement(_ui.AlyceDivider, {
      my: 1
    }), /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
      className: classes.listIcon
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.spyIcon,
      color: "text",
      icon: "user-secret"
    })), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.listItemText,
      primary: "".concat(contactTitle, " doesn't share much information in social media...")
    }))));
  }, [profile, classes, showEmptyTagsMessage, contactTitle, isLinksTagsEmpty, socialClickHandler, openLink]);
  var showUnsubscribedError = (0, _react.useMemo)(function () {
    return !isLoading && !!profile.isUnsubscribed;
  }, [profile.isUnsubscribed, isLoading]);
  var statistic = profile.statistic,
      latestGift = profile.latestGift,
      currentGift = profile.currentGift;
  var renderGiftStatistic = (0, _react.useMemo)(function () {
    return statistic && /*#__PURE__*/_react.default.createElement(_GiftsStatistic.default, {
      created: statistic.created,
      sent: statistic.sent,
      accepted: statistic.accepted,
      meetings: statistic.meetings,
      latestGift: latestGift,
      currentGift: currentGift,
      disableCreateGift: showUnsubscribedError,
      handleGiftViewHistory: handleGiftViewHistory,
      handleGiftCreate: handleGiftCreate,
      contact: profile
    });
  }, [statistic, latestGift, currentGift, showUnsubscribedError, handleGiftViewHistory, handleGiftCreate, profile]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, showUnsubscribedError && /*#__PURE__*/_react.default.createElement(_UnsubscribedErrorMessage.default, null), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ContactDetailsCard.default, {
    title: "".concat(contactTitle, "'s information"),
    isLoading: isLoading,
    render: function render() {
      return isLoading ? renderLoadingList : renderProfileList;
    }
  })), statistic && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ContactDetailsCard.default, {
    title: "Gift history",
    isLoading: isLoading,
    render: function render() {
      return isLoading ? renderLoadingList : renderGiftStatistic;
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ContactDetailsCard.default, {
    title: "".concat(contactTitle, "'s interests"),
    isLoading: isLoading,
    render: function render() {
      return isLoading ? renderLoadingList : renderResearchList;
    }
  })));
};

ContactProfile.propTypes = {
  profile: _profile.profileShape.isRequired,
  handleGiftViewHistory: _propTypes.default.func,
  handleGiftCreate: _propTypes.default.func,
  isLoading: _propTypes.default.bool,
  user: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    fullName: _propTypes.default.string,
    avatar: _propTypes.default.string,
    countryId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    orgName: _propTypes.default.string,
    orgId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }).isRequired
};
ContactProfile.defaultProps = {
  isLoading: false,
  handleGiftViewHistory: function handleGiftViewHistory() {},
  handleGiftCreate: function handleGiftCreate() {}
};
var _default = ContactProfile;
exports.default = _default;